import { render, staticRenderFns } from "./LanguageMove.vue?vue&type=template&id=3deda37c&"
import script from "./LanguageMove.vue?vue&type=script&lang=js&"
export * from "./LanguageMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports